import * as React from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { LeadPage } from './LeadPage'
import { ProtectedRouteWithToast } from '../Routes'
import { useCheckPermissions } from '@user/store/authorization/permissions'
import { ENTITY_TYPES } from '@sales-center/common'
import { EntityDetails } from '@user/features/EntityDetails/EntityDetails'
import { AddLeadPage as NewAddLeadPage } from './AddLeadPage/AddLeadPage'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { guestRoleName } from '@user/components/Settings/Users/UpdateUser/constants'

export function LeadRoutes() {
  const currentUser = useSelector(selectCurrentUser)
  const isGuestUser = currentUser?.roleName === guestRoleName
  const location = useLocation()

  const [
    canAddLeads,
    canViewLeads,
    canUpdateLeads,
    canDeleteLeads,
    canConvertLead,
  ] = useCheckPermissions(
    'leads_add',
    'leads_view',
    'leads_update',
    'leads_delete',
    'opportunities_convert_/_save_for_later',
  )

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRouteWithToast isAllowed={canViewLeads && !isGuestUser}>
            <LeadPage
              isDraft={false}
              canConvertLeads={canUpdateLeads && canConvertLead}
              canDeleteLeads={canDeleteLeads}
              canUpdateLeads={canUpdateLeads}
            />
          </ProtectedRouteWithToast>
        }
      />
      <Route
        path="/addLead"
        element={
          <ProtectedRouteWithToast isAllowed={canAddLeads}>
            <NewAddLeadPage key={location.pathname + location.search} />
          </ProtectedRouteWithToast>
        }
      />
      <Route
        path="/:id"
        element={
          <ProtectedRouteWithToast isAllowed={canViewLeads && !isGuestUser}>
            <EntityDetails
              canConvertEntity={canUpdateLeads && canConvertLead}
              canDeleteEntity={canDeleteLeads}
              canUpdateEntity={canUpdateLeads}
              entityType={ENTITY_TYPES.Lead}
            />
          </ProtectedRouteWithToast>
        }
      />
    </Routes>
  )
}
